export default __webpack_public_path__ + "static/media/empty.6603a223.png";